import React, { PureComponent } from 'react'
import { Cell } from 'react-sticky-table'
import { Icon } from 'components'
import moment from 'moment'
import 'moment-duration-format'

import './Race.css'

export function Race({ race }) {
    const { drivingStyle, engineMaintenance, gearboxMaintenance, hardness, pitstops, position, raceTime, actualPitstops } = race
    if (typeof race !== 'object') return <Cell />
    let time = typeof raceTime === 'string' && raceTime.includes('OUT') ? 'OUT' : raceTime
    if (time !== 'OUT') {
        time = raceTime ? moment.duration(raceTime, 'seconds').format('mm:ss') : '--:--'
    }
    return (
        <Cell>
            <div className="ST-Cell-race Mc-Race">
                <div className="ST-Cell-race__header flex row-stretch-center">
                    <div className="position">
                        <Icon name="shield" className="icon icon--secondary" />
                        <span className="position__value">{position}</span>
                    </div>
                    <div className="time">
                        <Icon name="clock" className="icon icon--right" />
                        <span className="time__value">{time}</span>
                    </div>
                </div>
                <div className="separator" />
                <div className="ST-Cell-race__body">
                    <div className="ST-Cell-race__row flex row-stretch-center">
                        <span className="label">Hardness:</span>
                        <span className="value">{hardness || '--'}</span>
                    </div>
                    <div className="ST-Cell-race__row flex row-stretch-center">
                        <span className="label">Driving style:</span>
                        <span className="value">{drivingStyle || '--'}</span>
                    </div>
                    <div className="ST-Cell-race__row flex row-stretch-center">
                        <span className="label">Pit lane stop plan:</span>
                        <span className="value">
                            {pitstops !== undefined ? pitstops : '--'} / {actualPitstops !== undefined ? actualPitstops : '--'}
                        </span>
                    </div>
                    <div className="separator" />
                    <div className="flex row-center ST-Cell-race__row--title">
                        <span>Mainenance strategy</span>
                    </div>
                    <div className="ST-Cell-race__row flex row-stretch-center">
                        <span className="label">Engine:</span>
                        <span className="value">{engineMaintenance || '--'}</span>
                    </div>
                    <div className="ST-Cell-race__row flex row-stretch-center">
                        <span className="label">Gearbox</span>
                        <span className="value">{gearboxMaintenance || '--'}</span>
                    </div>
                </div>
            </div>
        </Cell>
    )
}



// WEBPACK FOOTER //
// src/pages/MC/Game/Race/Race.js